export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white">
      <div className="px-6 lg:px-20 py-16">
        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-12">
          {/* Left Column - Logo & Tagline */}
          <div>
            <img 
              src="https://static.readdy.ai/image/65bc6cd4bf89e9871e78f57376195ee1/062fc0ccfb04948d5a479f8f6262a669.png" 
              alt="Artist Logo" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-gray-400 mb-6">
              Making Waves in Hip-Hop
            </p>
            {/* Streaming Links */}
            <div className="flex items-center gap-4 mb-6">
              <a href="https://spotify.com" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors duration-300 text-sm">
                Spotify
              </a>
              <span className="text-gray-700">|</span>
              <a href="https://music.apple.com" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors duration-300 text-sm">
                Apple Music
              </a>
              <span className="text-gray-700">|</span>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors duration-300 text-sm">
                YouTube
              </a>
            </div>
            <p className="text-xs text-gray-600">
              © {currentYear}&nbsp;Tha Realest. All Rights Reserved.
            </p>
          </div>

          {/* Middle Column - Quick Links */}
          <div>
            <h4 className="text-base font-bold uppercase tracking-wide mb-6">Quick Links</h4>
            <nav className="space-y-3">
              {['Home', 'About', 'Music', 'Videos', 'Merch', 'Contact'].map((item) => (
                <a
                  key={item}
                  href={`#${item.toLowerCase()}`}
                  className="block text-sm text-gray-400 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-cyan-400 hover:to-red-500 transition-all duration-300"
                >
                  {item}
                </a>
              ))}
            </nav>
          </div>

          {/* Right Column - Newsletter */}
          <div>
            <h4 className="text-base font-bold uppercase tracking-wide mb-4">Newsletter</h4>
            <p className="text-sm text-gray-400 mb-6">
              Stay updated with latest releases
            </p>
            <form className="space-y-3">
              <input
                type="email"
                placeholder="Your email"
                className="w-full px-4 py-3 bg-transparent border-2 border-gray-700 rounded-full text-white text-sm outline-none focus:border-cyan-400 transition-colors duration-300"
              />
              <button
                type="submit"
                className="w-full py-3 bg-gradient-to-r from-red-500 to-purple-600 text-white text-sm font-bold rounded-full hover:shadow-lg hover:shadow-red-500/50 transition-all duration-300 whitespace-nowrap"
              >
                SUBSCRIBE
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="px-6 lg:px-20 py-6">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-gray-500">
            {/* Copyright */}
            <div className="text-center">
              © {currentYear} Tha Realest. All Rights Reserved.
            </div>

            {/* Legal Links */}
            <div className="flex items-center gap-4">
              <a href="#" className="hover:text-cyan-400 transition-colors duration-300">
                Privacy Policy
              </a>
              <span className="text-gray-700">|</span>
              <a href="#" className="hover:text-cyan-400 transition-colors duration-300">
                Terms
              </a>
              <span className="text-gray-700">|</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors duration-300">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
